const articles = window.backerSparkArticles || [];
const params = new URLSearchParams(window.location.search);
const slug = params.get("slug");

const articleCount = document.querySelector("#articleCount");
const blogList = document.querySelector(".blog-list-section");
const grid = document.querySelector("#blogArticleGrid");
const articlePage = document.querySelector("#articlePage");
const relatedSection = document.querySelector("#relatedSection");
const title = document.querySelector("#articleTitle");
const summary = document.querySelector("#articleSummary");
const category = document.querySelector("#articleCategory");
const readTime = document.querySelector("#articleReadTime");
const published = document.querySelector("#articlePublished");
const content = document.querySelector("#articleContent");
const related = document.querySelector("#relatedArticles");
const blogHero = document.querySelector(".blog-hero");
const researchGrid = document.querySelector("#backerSkyResearchGrid");
const nativeArticleGrid = document.querySelector("#nativeArticleGrid");
const articleSearch = document.querySelector("#blogArticleSearch");
const filterButtons = [...document.querySelectorAll(".blog-filter")];
const resultsStatus = document.querySelector("#blogResultsStatus");
const researchArticles = articles
  .filter((article) => article.sourceUrl)
  .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));

const renderParagraphs = (body) => {
  const paragraphs = Array.isArray(body) ? body : [body];
  return paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join("");
};

const renderBullets = (bullets) => {
  if (!bullets?.length) return "";
  return `
    <ul>
      ${bullets.map((bullet) => `<li>${bullet}</li>`).join("")}
    </ul>
  `;
};

const cardMarkup = (article, index = 1) => `
  <a
    class="article-card article-link-card${index === 0 ? " is-featured" : ""}"
    href="/blogs/news?slug=${article.slug}"
    aria-label="Read ${article.title}"
  >
    <div class="article-meta">
      <span>${article.category}</span>
      <span>${article.readTime}</span>
    </div>
    <h3>${article.title}</h3>
    <p>${article.summary}</p>
    <span class="read-more">Read article</span>
  </a>
`;

const researchCardMarkup = (article, index) => `
  <a
    class="research-card${index === 0 ? " is-lead" : ""}"
    href="/blogs/news?slug=${encodeURIComponent(article.slug)}"
    aria-label="Read ${article.title}"
  >
    <div class="article-meta">
      <span>${article.category}</span>
      <span>${article.publishedAt}</span>
    </div>
    <h3>${article.title}</h3>
    <p>${article.summary}</p>
    <span class="research-source">Based on ${article.sourceLabel}</span>
    <span class="read-more">Read field note</span>
  </a>
`;

if (articleCount) {
  const nativeCount = Number(articleCount.dataset.nativeCount || 0);
  const visibleArticleCount = nativeCount + researchArticles.length || articles.length;
  articleCount.textContent = `${visibleArticleCount} articles`;
}

if (researchGrid) {
  researchGrid.innerHTML = researchArticles.map(researchCardMarkup).join("");
}

if (!slug) {
  if (grid) {
    grid.innerHTML = articles.map(cardMarkup).join("");
  }
} else {
  const article = articles.find((item) => item.slug === slug) || articles[0];
  document.body.classList.add("is-legacy-article-view");
  if (blogHero) blogHero.hidden = true;
  if (blogList) blogList.hidden = true;
  document.querySelectorAll(".blog-editorial-note, .blog-research-section, .blog-topic-nav, .blog-standards, .blog-conversion").forEach((section) => {
    section.hidden = true;
  });
  if (articlePage) articlePage.hidden = false;
  if (relatedSection) relatedSection.hidden = false;

  if (article) {
    document.title = `${article.title} | BackerSky Blog`;
    const canonical = document.querySelector('link[rel="canonical"]');
    const description = document.querySelector('meta[name="description"]');
    const canonicalUrl = `${window.location.origin}/blogs/news?slug=${encodeURIComponent(article.slug)}`;
    if (canonical) canonical.href = canonicalUrl;
    if (description) description.content = article.summary;
    title.textContent = article.title;
    summary.textContent = article.summary;
    category.textContent = article.category;
    readTime.textContent = article.readTime;
    if (published) published.textContent = `Published ${article.publishedAt || "Jul 2026"}`;
    content.innerHTML = article.sections
      .map(
        (section) => `
          <section>
            <h2>${section.heading}</h2>
            ${renderParagraphs(section.body)}
            ${renderBullets(section.bullets)}
          </section>
        `,
      )
      .join("");

    if (article.sourceUrl) {
      content.insertAdjacentHTML(
        "beforeend",
        `<aside class="article-source-note"><strong>Primary source</strong><p>This field note was reviewed against <a href="${article.sourceUrl}" target="_blank" rel="noopener">${article.sourceLabel}</a>. Platform features and eligibility can change, so confirm the current rule before launch.</p></aside>`,
      );
    }

    related.innerHTML = articles
      .filter((item) => item.slug !== article.slug)
      .slice(0, 3)
      .map((item) => cardMarkup(item))
      .join("");

    const schema = document.createElement("script");
    schema.type = "application/ld+json";
    schema.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "@id": `${canonicalUrl}#article`,
      headline: article.title,
      description: article.summary,
      datePublished: article.publishedAt ? new Date(article.publishedAt).toISOString() : undefined,
      dateModified: article.publishedAt ? new Date(article.publishedAt).toISOString() : undefined,
      inLanguage: "en-US",
      articleSection: article.category,
      mainEntityOfPage: { "@type": "WebPage", "@id": canonicalUrl },
      isPartOf: { "@id": `${window.location.origin}/blogs/news#blog` },
      author: { "@type": "Organization", "@id": `${window.location.origin}/#organization`, name: "BackerSky" },
      publisher: { "@type": "Organization", "@id": `${window.location.origin}/#organization`, name: "BackerSky" },
      citation: article.sourceUrl || undefined,
    });
    document.head.append(schema);
  }
}

const categoryGroups = {
  launch: ["launch", "pre-launch", "platform", "funding goal", "closing"],
  traffic: ["traffic", "ads", "email", "audience", "analytics"],
  trust: ["trust", "proof", "creative", "comments", "updates"],
  fulfillment: ["fulfillment", "shipping", "post-campaign", "rewards"],
};

let activeFilter = "all";

const filterNativeArticles = () => {
  if (!nativeArticleGrid) return;
  const query = (articleSearch?.value || "").trim().toLowerCase();
  const cards = [...nativeArticleGrid.querySelectorAll("[data-article-title]")];
  let visible = 0;

  cards.forEach((card) => {
    const haystack = `${card.dataset.articleTitle} ${card.dataset.articleCategory} ${card.dataset.articleSummary}`;
    const categoryMatch = activeFilter === "all"
      || (categoryGroups[activeFilter] || []).some((term) => haystack.includes(term));
    const queryMatch = !query || haystack.includes(query);
    const show = categoryMatch && queryMatch;
    card.hidden = !show;
    if (show) visible += 1;
  });

  if (resultsStatus) {
    resultsStatus.textContent = `${visible} ${visible === 1 ? "article" : "articles"} shown`;
  }
};

articleSearch?.addEventListener("input", filterNativeArticles);
filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    activeFilter = button.dataset.blogFilter;
    filterButtons.forEach((item) => item.classList.toggle("is-active", item === button));
    filterNativeArticles();
  });
});

filterNativeArticles();
